<div class="modal-header">
  <h2 class="modal-title">{{ title }}</h2>
</div>

<div class="modal-body">
  <p class="modal-message">{{ message }}</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">
    {{ cancelButtonText }}
  </button>
  <button *ngIf="tertiaryButtonText"
          type="button"
          class="btn"
          [ngClass]="tertiaryButtonClass"
          (click)="onTertiary()">
    {{ tertiaryButtonText }}
  </button>
  <button type="button" class="btn" [ngClass]="confirmButtonClass" (click)="onConfirm()">
    {{ confirmButtonText }}
  </button>
</div>
